//this function retru counter for how many feedbacks exist for particaul branch Id
function getNumberOfFeedbacksForAnId(data, id) {
  let count = 0;

  data.forEach((item) => {
    if (item.admin_id == id) count++;
  });
  return count;
}

export function browseFeedbackBranchwise(data, activeBranches) {
  if (data == null) return null;
  let Arr = [];
  let counter = 0;
  activeBranches.forEach((id) => {
    let temp = {
      bId: id,
      index: counter,
    };
    let numOfFeedback = getNumberOfFeedbacksForAnId(data, id);
    counter += numOfFeedback;
    Arr.push(temp);
  });

  return Arr;
}
